// Shared styles for dashboard stat cards

export const statBoxStyle = {
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  px: 3,
  py: 0.8,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: 95
};

export const statValueStyle = {
  fontWeight: 700,
  fontSize: '1.7rem',
  lineHeight: 1.2
};

export const statLabelStyle = {
  fontWeight: 600,
  fontSize: '0.85rem',
  whiteSpace: 'nowrap',
  lineHeight: 1.2
};
